import React, { Component } from 'react';
import ChevronDown from "./images/ChevronDown";

class ResearchItem extends Component {
    render() {
        return (
            <div style={researchWrapperStyle}>
                <div style={researchIconStyle}>
                    <p style={iconDateStyle}>{ this.props.research.date }</p>
                </div>
                <div style={researchStyle}>
                    <p style={resHeaderStyle}>{ this.props.research.title }</p>
                    <p style={resSubHeaderStyle}>{ this.props.research.authors }</p>
                    <hr style={hr}/>
                    <div style={resAbstractStyle}>
                        <p style={resAbstractTextStyle}>{ this.props.research.text }</p>
                    </div>
                    <div style={resLinkStyle}>
                        <a href={ this.props.research.link }>
                            <ChevronDown fill={'#777'} style={chevronStyle}/>
                            <p style={resLinkTextStyle}>
                                View More
                            </p>
                        </a>
                    </div>
                </div>
            </div>  
        );
    }
}

const researchWrapperStyle = {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'auto',
}

const researchIconStyle = {
    height: '200px',
    width: '160px',
    margin: '14px 10px 10px 20px',
    borderRadius: '6px',
    textAlign: 'right'
}

const iconDateStyle = {
    fontFamily: 'Titillium Web, sans-serif',
    fontSize: '16px',
    fontStyle: 'italic',
    color: '#aaa',
    margin: '0px 10px 4px 10px',
}

const researchStyle = {
    width: '550px',
    backgroundColor: '#eee',
    margin: '10px 30px 20px 10px',
    borderRadius: '6px',
}

const resHeaderStyle = {
    fontFamily: 'Titillium Web, sans-serif',
    fontSize: '20px',
    margin: '10px 10px 2px 10px'
}

const resSubHeaderStyle = {
    fontFamily: 'Titillium Web, sans-serif',
    fontSize: '20px',
    color: '#888',
    margin: '2px 5px 4px 5px'
}

const resAbstractStyle = {
    height: '255px',
    width: '500px',
    margin: '0px auto',
    textAlign: 'justify',
    overflowY: 'hidden',
    padding: '0px 10px 0px 10px'
}

const resAbstractTextStyle = {
    fontFamily: 'Titillium Web, sans-serif',
    fontSize: '20px',
    fontStyle: 'italic',
    height: '165px',
    color: '#555',
}

const resLinkStyle = {
    height: '30px',
    width: '160px',
    margin: '10px 10px 4px 360px',
    textAlign: 'right'
}

const resLinkTextStyle = {
    fontFamily: 'Titillium Web, sans-serif',
    fontSize: '20px',
}

const hr = {
    height: '2px',
    width: '80%',
    border: '0',
    borderTop: '1px solid #aaa',
    margin: '12px auto',
    padding: '0'
}

const chevronStyle = {
    float: 'right',
    width: '14px',
    height: '14px',
    margin: '7px 0px 0px 4px',
    transform: 'rotate(-90deg)'
}

export default ResearchItem